import React, { ReactElement, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import ClassType from '../../model/pripomienka/ClassType';
import PripomienkaDetail from '../../model/pripomienka/PripomienkaDetail';
import defaultEditPripomienka from './component/data/defaultEditPripomienka';
import { useSuccessMessageContext } from '../../context/SuccessMessageContext';
import SaveAdminPripomienka from '../../model/pripomienka/SaveAdminPripomienka';
import { useClient } from '../../context/ClientStatusContext';
import { editPripomienkaAdmin } from '../../client/editPripomienkaClient';
import useFieldErrorMessages from '../useFieldErrorMessages';
import { SafeParameterSetter } from '../../types/SafeParameterSetter';
import routes from '../../routing/routes';
import CreateAndUpdatePripomienkaAdminComponent
  from './component/CreateAndUpdatePripomienkaAdminComponent';

interface Props {
  classType: ClassType;
  pripomienkaDetail: PripomienkaDetail;
}
const EditPripomienkaAdmin = ({
  classType, pripomienkaDetail,
}: Props): ReactElement => {
  const {
    type, year, index, uuid,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, uuid: string }>();
  const navigate = useNavigate();
  const { displaySuccess } = useSuccessMessageContext();

  const [pripomienka, setPripomienka] = useState<SaveAdminPripomienka>(defaultEditPripomienka(pripomienkaDetail));
  const { status, wrapClient } = useClient(editPripomienkaAdmin);

  const { clearFieldErrorMessage, getFieldErrorMessage } = useFieldErrorMessages();

  const updateField: SafeParameterSetter<SaveAdminPripomienka> = (fieldName, value) => {
    setPripomienka(prevState => ({ ...prevState, [fieldName]: value }));
    clearFieldErrorMessage(fieldName);
    if (fieldName === 'ine' || fieldName === 'odsek' || fieldName === 'paragraf'
      || fieldName === 'clanok' || fieldName === 'celyMaterial') {
      clearFieldErrorMessage('pripomienkaK');
    }
  };

  const handleSubmit = async (): Promise<void> => {
    await wrapClient(
      classType,
      type,
      year,
      index,
      uuid,
      pripomienka,
    );
    if (classType === ClassType.PRIPOMIENKA) {
      navigate(routes.pripomienky.detail.withParams(type, year, index, uuid));
      displaySuccess('Pripomienka bola úspešne upravená.');
    } else {
      navigate(routes.hromadnePripomienky.detail.withParams(type, year, index, uuid));
      displaySuccess('Hromadná pripomienka bola úspešne upravená.');
    }
  };

  return (
    <CreateAndUpdatePripomienkaAdminComponent
      classType={classType}
      pripomienka={pripomienka}
      onUpdateField={updateField}
      submitStatus={status}
      onSubmit={handleSubmit}
      getFieldErrorMessage={getFieldErrorMessage}
    />
  );
};

export default EditPripomienkaAdmin;
